import Vue from 'vue'
import Router from 'vue-router'
import store from 'store'
import Home from 'views/Home'
import Debug from 'views/Debug'
import CustomersList from 'views/Customers/CustomersList'
import ProspectsList from 'views/Customers/ProspectsList'
import Customer from 'views/Customers/Customer'
import DomiciliationContractsList from 'views/DomiciliationContracts/DomiciliationContractsList'
import LongTermLocationsList from 'views/LongTermLocations/LongTermLocationsList'
import OrdersTab from 'components/Customer/OrdersTab'
import OrderInvoice from 'components/Customer/OrderInvoice'
import InformationsContentTab from 'components/Customer/InformationsContentTab'
import ContractManagement from 'components/Customer/ContractManagement'
import ConsumptionsProducts from 'views/ConsumptionProducts'
import Catalogs from 'views/Catalogs'
import Cash from 'views/Cash'
/*import DomiciliationSubTab from 'components/Customer/ContractManagementContent/Domiciliation'
 import ForwardingAddressesSubTab from 'components/Customer/ContractManagementContent/ForwardingAddresses'*/
import OneTimeLocations from 'views/OneTimeLocations/OneTimeLocations'

// EDITIONS PAGES
import Edit from 'views/Edit/Edit'
import EditGeneral from 'components/Edit/Customer/InformationsContent/EditGeneral'
import EditAddresses from 'components/Edit/Customer/InformationsContent/EditAddresses'

import CreateProspect from 'views/Prospects/CreateProspect'

// ERROR PAGES
import NotFound from 'views/ErrorPages/NotFound'
import InternalServerError from 'views/ErrorPages/InternalServerError'

// DEMANDES PAGES
import Demands from 'views/Demands/Demands'
import LoneDemand from 'views/Demands/LoneDemand'
import Crm from 'views/CRM/Crm'
import Lead from "views/CRM/Lead"
// import PunctualRentals from 'views/PunctualRentals'
import Hotline from 'views/Hotline/Hotline'

// NOTIFICATIONS
import Notifications from 'views/Notifications/Notifications'

// LOYALTY PROGRAM
import LoyaltyProgramSubscriptions from 'views/LoyaltyProgramSubscriptions/LoyaltyProgramSubscriptions'

// Users
import Users from 'views/Users/UsersList'

Vue.use(Router)

// scrollBehavior:
// - only available in html5 history mode
// - defaults to no scroll behavior
// - return false to prevent scroll
const scrollBehavior = (to, from, savedPosition) => {
    if (savedPosition) {
        // savedPosition is only available for popstate navigations.
        return savedPosition
    } else {
        const position = {}
        // new navigation.
        // scroll to anchor by returning the selector
        if (to.hash) {
            position.selector = to.hash
        }
        // check if any matched route config has meta that requires scrolling to top
        if (to.matched.some(m => m.meta.scrollToTop)) {
            // cords will be used if no selector is provided,
            // or if the selector didn't match any element.
            position.x = 0
            position.y = 0
        }
        // if the returned position is falsy or an empty object,
        // will retain current scroll position.
        return position
    }
}

export default new Router({
    mode: 'history',
    scrollBehavior,
    routes: [
        {
            name: 'home',
            path: '/',
            component: Home,
            meta: {
                breadcrumb: {
                    eraseAll: true,
                    displayName: "Dashboard"
                }
            }
        },
        {
            name: 'code_404',
            path: '/404',
            component: NotFound,
            meta: {
                breadcrumb: {
                    eraseAll: true,
                    eraseAfter: true,
                    displayName: "Erreur 404"
                }
            }
        },
        {
            name: 'code_500',
            path: '/500',
            component: InternalServerError,
            meta: {
                breadcrumb: {
                    eraseAll: true,
                    eraseAfter: true,
                    displayName: "Erreur 500"
                }
            }
        },
        {
            name: 'debug',
            path: '/debug',
            component: Debug,
            meta: {
                breadcrumb: {
                    eraseAll: true,
                    eraseAfter: true,
                    displayName: "Informations version"
                }
            }
        },
        {
            name: 'login',
            path: '/login'
        },
        {
            name: 'create-prospects',
            path: '/prospects/create',
            component: CreateProspect,
            meta: {
                breadcrumb: {
                    eraseAfter: true,
                    displayName: "Création de Prospect",
                }
            }
        },
        {
            name: 'customers',
            path: '/customers',
            component: CustomersList,
            meta: {
                breadcrumb: {
                    displayName: "Clients"
                }
            }
        },
        {
            name: 'prospects',
            path: '/prospects',
            component: ProspectsList,
            meta: {
                breadcrumb: {
                    displayName: "Prospects"
                }
            }
        },
        {
            path: '/customer/:id',
            component: Customer,
            props: (route) => ({
                customerId: Number(route.params.id),
                contractId: Number(route.params.contractId)
            }),
            children: [
                {
                    name: 'customer',
                    path: '',
                    components: {
                        orders: OrdersTab,
                        informations: InformationsContentTab,
                    },
                    meta: {
                        breadcrumb: {
                            module: 'customer',
                            stateProp: 'profile',
                            displayName: (profile) => `Client ${profile.name}`
                        }
                    }
                },
                {
                    name: 'customer-tab',
                    path: ':tab',
                    redirect: to => {
                        const { hash, params, query } = to

                        return {
                            name: 'customer',
                            params: {
                                id: params.id,
                                tab: params.tab,
                                query: query
                            }, 
                            query: {}
                        }
                    }
                },
                {
                    name: 'order-invoice',
                    path: 'order/:orderId',
                    components: {
                        orders: OrderInvoice,
                        informations: InformationsContentTab,
                    },
                    meta: {
                        //TODO: when implemented
                        breadcrumb: {
                            module: 'customer',
                            stateProp: 'profile',
                            displayName: (profile) => `Commande ${profile.name}`
                        }
                    }
                },
                {
                    name: 'contract-management',
                    path: 'contract/:contractId',
                    components: {
                        informations: ContractManagement,
                        orders: OrdersTab,
                    },
                    meta: {
                        breadcrumb: {
                            module: 'contract',
                            stateProp: 'id',
                            displayName: (id) => `Contract #${id}`
                        }
                    }
                }
            ]
        },
        {
            name: 'domiciliations',
            path: '/domiciliations',
            component: DomiciliationContractsList
        },
        {
            name: 'locations',
            path: '/locations',
            component: LongTermLocationsList
        },
        {
            name: 'consumptions',
            path: '/consumptions',
            component: ConsumptionsProducts
        },
        {
            name: 'one-time-locations',
            path: '/one-time-locations',
            component: OneTimeLocations
        },
        {
            path: '/edit',
            component: Edit,
            children: [
                {
                    name: 'generals-edition',
                    path: 'generals/:id',
                    component: EditGeneral
                },
                {
                    name: 'addresses-edition',
                    path: 'addresses/:id',
                    component: EditAddresses
                }
            ]
        },
        {
            name: 'catalogs',
            path: '/catalogs',
            component: Catalogs
        },
        {
            name: 'single-demand',
            path: '/single-demand/:id',
            component: LoneDemand,
            props: (route) => ({
                requestId: Number(route.params.id),
            }),
            children: []
        },
        {
            name: 'demands',
            path: '/demands',
            component: Demands
        },
        {
            name: 'cash',
            path: '/cash',
            component: Cash
        },
        {
            name:'hotline',
            path:'/hotline',
            component:Hotline,
        },
        {
            name:'crm',
            path:'/crm',
            component:Crm
        },
        {
            name:"lead",
            path:"/lead/:id",
            component:Lead,
        },
        {
            name: 'notifications',
            path: '/notifications',
            component: Notifications
        },
        {
            name: 'loyaltyProgram',
            path: '/loyalty-program-subscriptions',
            component: LoyaltyProgramSubscriptions
        },
        {
            name: 'users',
            path: '/users',
            component: Users,
            beforeEnter: (to, from, next) => {
                if (store.getters.isAdmin || store.getters.isUserManager) {
                    next()
                } else {
                    next('/')
                }
            }
        },
        {
            name: 'worldlineReturn',
            path: '/worldline_return/:result',
            redirect: to => {
                const { hash, params, query } = to

                let redirect = {
                    name: 'home',
                    params: {},
                    query: {}
                }

                if (['cancel', 'success', 'error', 'pending'].indexOf(params.result) !== -1) {
                    redirect.params.notify = true

                    if ('cancel' === params.result) {
                        redirect.params.notificationType = 'warning'
                        redirect.params.notificationMessage = 'Le paiement en ligne a été annulé'
                    } else if ('pending' === params.result) {
                        redirect.params.notificationType = 'warning'
                        redirect.params.notificationMessage = 'Un paiement est en cours de vérification, merci de réessayer dans quelques minutes.'
                    } else if ('success' === params.result) {
                        redirect.params.notificationType = 'complete-success'
                        redirect.params.notificationMessage = 'Le paiement en ligne a été réalisé avec succès'
                    } else {
                        redirect.params.notificationType = 'error'
                        redirect.params.notificationMessage = "Une erreur s'est produite suite au paiement, merci de prendre contact avec le support technique"
                    }
                }

                if (['customer', 'single-demand'].indexOf(query.route_name) !== -1 && query.route_id !== undefined && query.route_id.length > 0) {
                    redirect.name = query.route_name
                    redirect.params.id = query.route_id

                    if (query.hasOwnProperty('tab')) {
                        redirect.params.tab = query.tab
                    }
                } else if (['cash'].indexOf(query.route_name) !== -1) {
                    redirect.name = query.route_name
                }

                return redirect
            }
        }
    ]
})



// WEBPACK FOOTER //
// ./client/router/index.js